import { TEAMS_SORTABLE_FIELDS } from "@components/table/teams/teams-table-constants";
import { MemberRoleTypes } from "@custom-types/member-types";
import { FaroCoreApiTypes } from "@stellar/core-api-client";

/**
 * Team member types to use in Sphere Dashboard
 * The property "role" is to defined here because "role" is required in company member type
 */
export interface SdbTeamMemberBase extends FaroCoreApiTypes.UserAsManager {
  role: MemberRoleTypes;
}

/** Base props for a team */
export interface BaseTeamProps {
  /** Team entity */
  team: FaroCoreApiTypes.Team;
}

/**
 * This type covers all team types returned from different routes
 * The purpose of it is to remove the confusion between all these types
 */
export type SdbTeam = FaroCoreApiTypes.Team & {
  role: MemberRoleTypes;

  /** If the kind of the team is provided it is always user-group */
  kind?: "user-group";
};

/** Available team sort fields - derived from TEAMS_SORTABLE_FIELDS */
export type TeamsSortField = (typeof TEAMS_SORTABLE_FIELDS)[number];

/** Sortable column fields for the teams table */
export const TEAMS_SORT_BY = [
  "name_ascending",
  "name_descending",
  "users_ascending",
  "users_descending",
  "creation_date_ascending",
  "creation_date_descending",
  "workspace_role_ascending",
  "workspace_role_descending",
] as const;

/** All possible teams sort by values */
export type TeamsSortBy = (typeof TEAMS_SORT_BY)[number];
